/* eslint-disable */
import React from "react";

// mui imports
import { ListItemIcon, List, styled, ListItemText, Chip, useTheme, Typography, ListItemButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

function NavItem({ item, level, pathDirect, hideMenu, onClick }) {
  const customizer = useSelector(state => state.customizer);
  const Icon = item?.icon;
  const theme = useTheme();
  const { t } = useTranslation();
  const itemIcon = level > 1 ? <Icon stroke={1.5} size="1rem" /> : <Icon stroke={1.5} size="1.3rem" />;
  const pathArr = pathDirect.split("/");
  const itemHrefArr = item.href.split("/");
  const currentPath = pathDirect.split("?")[0];
  const ListItemStyled = styled(ListItemButton)(() => ({
    whiteSpace: "nowrap",
    marginBottom: "2px",
    padding: "8px 10px",
    borderRadius: `${customizer?.borderRadius}px`,
    backgroundColor: level > 1 ? "transparent !important" : "inherit",
    color:
      level > 1 && item?.href.includes(pathDirect) && itemHrefArr[1] === pathArr[1] && itemHrefArr[2] === pathArr[2] && itemHrefArr[4] === pathArr[4]
        ? `${theme.palette.primary.main}!important`
        : theme.palette.text.secondary,
    paddingLeft: hideMenu ? "10px" : level > 2 ? `${level * 15}px` : "10px",
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.main,
    },
    "&.Mui-selected": {
      color: "white",
      backgroundColor: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
        color: "white",
      },
    },
  }));

  const listItemProps = {
    component: item?.external ? "a" : Link,
    to: item?.href,
    href: item?.external ? item?.href : "",
    target: item?.external ? "_blank" : "",
  };

  return (
    <List component="li" disablePadding key={item?.id && item.title}>
      <Link to={item.href}>
        <ListItemStyled
          // {...listItemProps}
          disabled={item?.disabled}
          selected={pathDirect === item?.href || (item?.childPaths || []).some(cp => currentPath.startsWith(cp))}
          onClick={onClick}
          sx={{ paddingLeft: hideMenu ? "7px" : "10px" }}
        >
          <ListItemIcon
            sx={{
              minWidth: "36px",
              p: "3px 0",
              color: level > 1 && pathDirect === item?.href ? `${theme.palette.primary.main}!important` : "inherit",
            }}
          >
            {itemIcon}
          </ListItemIcon>
          <ListItemText>
            {hideMenu ? "" : <>{t(`${item?.title}`)}</>}
            <br />
            {item?.subtitle ? <Typography variant="caption">{hideMenu ? "" : item?.subtitle}</Typography> : ""}
          </ListItemText>

          {!item?.chip || hideMenu ? null : <Chip color={item?.chipColor} variant={item?.variant ? item?.variant : "filled"} size="small" label={item?.chip} />}
        </ListItemStyled>
      </Link>
    </List>
  );
}

export default NavItem;
